import { useEffect, useRef, useState } from 'react';

const C = {
  surface: '#111827', border: '#1e2d45', accent: '#00D4AA',
  text: '#E8EDF5', muted: '#6b7fa3', navy: '#003366',
};

const ICON = { message: '', payment: '💸', call: '📞' };

function SingleToast({ notif, onDismiss, onOpen }) {
  const [progress, setProgress] = useState(100);
  const [leaving, setLeaving] = useState(false);
  const [entered, setEntered] = useState(false);
  const rafRef = useRef(null);
  const startRef = useRef(Date.now());
  const DURATION = 4000;

  useEffect(() => {
    const frame = requestAnimationFrame(() => setEntered(true));
    const tick = () => {
      const elapsed = Date.now() - startRef.current;
      const pct = Math.max(0, 100 - (elapsed / DURATION) * 100);
      setProgress(pct);
      if (pct > 0) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        handleDismiss();
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(frame);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  const handleDismiss = () => {
    setLeaving(true);
    setTimeout(() => onDismiss(notif.id), 320);
  };

  const handleOpen = () => {
    setLeaving(true);
    setTimeout(() => { onDismiss(notif.id); onOpen(notif); }, 220);
  };

  const initials = (notif.senderName || '?')
    .split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();

  return (
    <div style={{
      transform: leaving || !entered ? 'translateX(120%)' : 'translateX(0)',
      transition: 'transform 0.32s cubic-bezier(0.4,0,0.2,1)',
      background: C.surface,
      border: `1px solid ${C.border}`,
      borderRadius: 16,
      padding: '12px 14px 0',
      width: 300,
      boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
      overflow: 'hidden',
      marginBottom: 10,
      flexShrink: 0,
    }}>
      <div style={{ display: 'flex', gap: 11, alignItems: 'flex-start', paddingBottom: 10 }}>
        {/* Avatar */}
        <div style={{
          width: 38, height: 38, borderRadius: '50%', flexShrink: 0,
          background: `linear-gradient(135deg,${C.accent}cc,${C.accent}44)`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 13, fontWeight: 700, color: '#fff',
        }}>
          {notif.type !== 'message' ? ICON[notif.type] : initials}
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.text, marginBottom: 2 }}>
            {notif.senderName}
          </div>
          <div style={{
            fontSize: 12, color: C.muted,
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          }}>
            {notif.preview}
          </div>
        </div>

        <div style={{ display: 'flex', gap: 5, alignItems: 'center', flexShrink: 0, marginLeft: 4 }}>
          {notif.conversationId && (
            <button onClick={handleOpen} style={{
              padding: '4px 10px', background: C.accent, border: 'none',
              borderRadius: 8, cursor: 'pointer', fontSize: 11, fontWeight: 700, color: '#000',
            }}>Voir</button>
          )}
          <button onClick={handleDismiss} style={{
            background: 'none', border: 'none', color: C.muted,
            cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: '2px 4px',
          }}>×</button>
        </div>
      </div>

      {/* Progress bar */}
      <div style={{ height: 3, background: '#1a2235', marginLeft: -14, marginRight: -14 }}>
        <div style={{
          height: '100%', background: C.accent,
          width: `${progress}%`, transition: 'width 0.08s linear',
          borderRadius: '0 2px 2px 0',
        }} />
      </div>
    </div>
  );
}

export default function NotificationToast({ notifications, onDismiss, onOpen }) {
  if (!notifications || notifications.length === 0) return null;
  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700&display=swap');`}</style>
      <div style={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
        display: 'flex', flexDirection: 'column-reverse', alignItems: 'flex-end',
        fontFamily: "'Sora', sans-serif",
        pointerEvents: 'none',
      }}>
        {notifications.slice(0, 3).map(notif => (
          <div key={notif.id} style={{ pointerEvents: 'all' }}>
            <SingleToast notif={notif} onDismiss={onDismiss} onOpen={onOpen} />
          </div>
        ))}
      </div>
    </>
  );
}
